/* eslint-disable react/no-array-index-key */
import React, { useMemo } from "react";
import _ from "lodash";

import TreeItem from "../TreeItem";
import { indexCourseLevelItems, mergeCourseLevelItems } from "../../../business/course/courseSurveys";

import { Container } from "./styles";

function CourseTree({ level, openCourseProgress, closeCourseProgress, data, objectsList, course, aboutProcess = false, idCourseParam = null,}) {

  const objectsWithAbout = useMemo(() => {

    const hasCourseSurveys = aboutProcess && _.get(course, 'type') !== "TRAIL" && (_.get(course, 'surveys') || []).length > 0;

    if((!data || !data.length) && !hasCourseSurveys){
      return [];
    }

    if(!aboutProcess){
      return data;
    }

    const courseType = _.get(course, 'type');

    if(courseType === "TRAIL"){
      // insert about trail as object
      const aboutTrail = _.get(course, 'about.0', null);
      data.unshift({
        ...aboutTrail, 
        type: "ABOUT"
      });
      const objects = data.map(item => {
        const type = _.get(item, 'type', null)
        const about = _.get(item, 'about.0', null);

          // insert children about
          const childrenCourse = _.get(item, 'children', []);
          // removing about from children
          const childrenWithoutAbout = childrenCourse.filter(child => !child.tags.includes("ABOUT") && child.type !== "KNOW_MORE");
          if(type === "COURSE"){
            const itemWithAbout = {
              ...about, 
              type: "ABOUT",
            }
            childrenWithoutAbout.unshift(itemWithAbout);
          }
    
          return {
            ...item,
            children: childrenWithoutAbout,
          }
      });
      const firstAbout = objects.find(o => o.type === "ABOUT"|| o.tags.includes("ABOUT"))
      const objectsWithAbout = objects.filter(o => o.type !== "ABOUT" || (o.tags && !o.tags.includes("ABOUT")))
      
      // Preservar o índice original dos cursos para que defaultSelectedCourse funcione corretamente
      const result = [firstAbout, ...objectsWithAbout];
      return result.map((item, index) => {
        if (item.type === "COURSE") {
          // Para cursos, manter o índice original (sem o "Sobre")
          return { ...item, index: index - 1 };
        }
        return { ...item, index };
      });
    } 

    return indexCourseLevelItems(mergeCourseLevelItems({ ...course, children: data || [] }));

  }, [data, course, aboutProcess]);

  return (
    <Container level={level}>
      {/* TODO: The children need to know prev and next sibilings. We need to do that using store and not passing as props. */}
      {objectsWithAbout && objectsWithAbout.length > 0 && objectsWithAbout.map((child, i, array) => {
        return (
          <TreeItem
            data={{ ...child, index: child.index !== undefined ? child.index : i, listContent: array }}
            level={level}
            key={i}
            openCourseProgress={openCourseProgress}
            closeCourseProgress={closeCourseProgress}
            objectsList={objectsList}
            course={course}
            idCourseParam={idCourseParam}
          />
        )
      })}
    </Container>
  );
}

export default CourseTree;
